import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/questionnaires'
)({
  staticData: { pageHeader: { title: 'Questionnaires', pad: false } },
})
